import { useAuthContext } from "./useAuthContext";
import { useState, useEffect } from "react";
import axios from "axios";

export const useAuthorization = (requiredPermission) => {
  const { user } = useAuthContext();
  const clubDetailsRaw = localStorage.getItem("club_details");
  const clubDetails = clubDetailsRaw ? JSON.parse(clubDetailsRaw) : null;
  const clubId = clubDetails?.club_id ?? null;

  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const fetchAuthorization = async () => {
      if (!user || !clubId || !requiredPermission) return;

      try {
        const response = await axios.get(`/api/roles/user-roles`, {
          params: { userId: user.userId },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });

        const clubRoles = response.data.filter(
          (role) => role.club_id === clubId
        );

        const permissionsResponses = await Promise.all(
          clubRoles.map((role) =>
            axios.get(`/api/roles/role-permissions/${role.id}`, {
              headers: {
                Authorization: `Bearer ${user.token}`,
              },
            })
          )
        );

        const allPermissions = new Set();
        permissionsResponses.forEach((res) => {
          res.data.forEach((p) => allPermissions.add(p.permission));
        });

        setIsAuthorized(
          user.role === "club_manager" || allPermissions.has(requiredPermission)
        );
      } catch (error) {
        console.error("Error checking authorization:", error);
        if (error.response.status == 401) {
          setIsAuthorized(false);
          localStorage.removeItem("club_admin");
          localStorage.removeItem("club_details");
        }
      }
    };

    fetchAuthorization();
  }, [user, clubId, requiredPermission]);

  return isAuthorized;
};
